import React from 'react';
import { Tag, theme } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import { StepContainer } from './SiteConfigurationContent.styles';
import SiteConfigurationSection from './SiteConfigurationSection';
import { TIER_OPTIONS } from '@/store/SiteSurveyForm/constants';
import { observer } from 'mobx-react-lite';
import { SiteConfigurationContentProps } from './SiteConfigurationContent.utils';
const { useToken } = theme;

const SiteConfigurationContent = observer(
  ({
    siteSurveyStore,
    isCustomerInformationStepOpen,
    toggleCustomerInformationStep,
    renderCustomerInformationStepContent,
    form,
  }: SiteConfigurationContentProps) => {
    const { token } = useToken();

    const currentTier = form.getFieldValue('tier');

    const getTierLabel = (value: string) => {
      if (!value) return '';
      const tierOption = TIER_OPTIONS.find(option => option.value === value);
      return tierOption ? t(tierOption.label) : '';
    };

    const tierTag = !currentTier ? null : (
      <Tag color="blue" className="tier-tag">
        {getTierLabel(currentTier)}
      </Tag>
    );

    return (
      <StepContainer token={token} $isOpen={isCustomerInformationStepOpen}>
        <div className="collapsible-section">
          {!isCustomerInformationStepOpen && (
            <div className="customer-information-step-form">
              <div className="collapsed-customer-information-step-form">
                <div className="toggle-button" onClick={toggleCustomerInformationStep}>
                  <div className="arrow-icon-container">
                    <DownOutlined />
                  </div>
                </div>
                <div className="form-header">{t('confirmCustomerDetails')}</div>
                <div className="customer-name">{siteSurveyStore.customerInformationData.customer?.name || ''}</div>
                <div>
                  <div className="account-id-wrapper">
                    <span className="account-id-label">{t('Salesforce account ID')}</span>
                    <span>
                      {siteSurveyStore.customerInformationData.customer?.accountId || ''}
                    </span>
                    {tierTag}
                  </div>
                </div>
              </div>
            </div>
          )}

          {isCustomerInformationStepOpen && (
            <div className="expanded-customer-information-step-form">
              <div className="toggle-button" onClick={toggleCustomerInformationStep}>
                <div className="arrow-icon-container">
                  <DownOutlined />
                </div>
              </div>
              <div className="collapsible-content-container">
                {isCustomerInformationStepOpen && renderCustomerInformationStepContent()}
              </div>
            </div>
          )}
        </div>
        <SiteConfigurationSection form={form} />
      </StepContainer>
    );
  },
);

export default SiteConfigurationContent;
